module.exports = __webpack_public_path__ + "images/emoji/fire.9524d450b3bec5ee602b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/fire.png
// module id = cpd4
// module chunks = 13